export default () => ({
    hasScroll: false,
    startedScroll: 0,
    finishedScrolling: 0,

    init() {
        this.$nextTick(() => {
            if(!this.$refs.content) return

            this.hasScroll = this.$refs.content.scrollWidth > this.$refs.content.clientWidth;

            if (this.hasScroll && window.innerWidth >= 830) {
                this.$refs.content.addEventListener('wheel', (event) => {
                    event.preventDefault();
                    this.$refs.content.scrollLeft += event.deltaY;
                });
            }
        });

        this.listenHover()
    },

    scrolled() {
        const element = this.$event.target;
        this.startedScroll = element.scrollLeft > 0;

        this.hasScroll = element.scrollLeft + element.offsetWidth < this.$refs.content.scrollWidth;
        this.finishedScrolling = (element.scrollLeft + element.offsetWidth + 1) >= this.$refs.content.scrollWidth;
    },

    listenHover() {
        const [header, total, container] = this.$refs.tableBody.children;
        const hoverClass = 'bg-blue-150';

        const bindHoverEvents = (element, index) => {
            element.addEventListener('mouseover', () => manageHoverClass(index, 'add'));
            element.addEventListener('mouseout', () => manageHoverClass(index, 'remove'));
        };

        const manageHoverClass = (index, action) => {
            header.children[index].classList[action](hoverClass);
            total.children[index].classList[action](hoverClass);

            Array.from(container.children).forEach(containerChildren => {
                containerChildren.children[index].classList[action](hoverClass);
            });
        };

        Array.from(header.children).forEach((headerChildren, index) => {
            bindHoverEvents(headerChildren, index);
            bindHoverEvents(total.children[index], index);

            Array.from(container.children).forEach((content) => {
                bindHoverEvents(content.children[index], index);
            });
        });
    }
})
